<template>
    <div class="ui-content dashboard allindtest cust-data-table-height">
      <div  class="page-user user ">
        <v-tabs 
          v-model="tab"
          background-color
          class="elevation-2 cust-tab"
          :centered="centered"
          :grow="grow"
          :vertical="vertical"
          :right="right"
          :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
          :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
          :icons-and-text="icons"
        >
          <v-tabs-slider></v-tabs-slider>
          
          <v-tab v-if="isOfflineTestVisible().isOnline" :href="'#Online'">Online</v-tab>
          <v-tab  v-if="isOfflineTestVisible().isOffline" :href="'#Offline'">Offline</v-tab>
          <v-tab  v-if="isOfflineTestVisible().isOffline && instituteId != CONSTANTS_REF.AITS_INSTITUTE_ID[0] && showAITSTab" :href="'#AITS'">A.I.T.S</v-tab>
          <v-tabs-items  :touchless="true" v-model="tab">
            <div v-if="!isOfflineTestVisible().isOnline && !isOfflineTestVisible().isOffline">
                <UpgradeTestModal :data="popUpMessage" />
            </div>
            <v-tab-item v-if="isOfflineTestVisible().isOnline" :value="'Online'">
              <!--v-card class="mx-auto normal-card"-->
                <CustomizedTest :tab='tab' :value="'Online'" :isOnlineOfflineTest="isOfflineTestVisible()"
                />
              <!--/v-card-->
            </v-tab-item>
            <v-tab-item  v-if="isOfflineTestVisible().isOffline" :value="'Offline'">
              <!--v-card class="mx-auto normal-card"-->
                <CustomizedTest :tab='tab' :value="'Offline'" :isOnlineOfflineTest="isOfflineTestVisible()"
                />
              <!--/v-card-->
            </v-tab-item>
            <v-tab-item  v-if="isOfflineTestVisible().isOffline && showAITSTab" :value="'AITS'">
                <CustomizedTest :tab='tab' :value="'AITS'" :isOnlineOfflineTest="isOfflineTestVisible()"
                />
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </div>
    </div>
  
</template>

<script>
import TestList from "@/components/coordinator/Tests/TestList.vue";
import CustomizedTest from './CustomizedTest.vue';
import UpgradeTestModal from "@/components/coordinator/Tests/UpgradeTestModal.vue";
import constants from "../../../utils/constants";
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  name: "CustomizeTestTabs",
  components: {
    TestList,
	CustomizedTest,
  UpgradeTestModal
  },
  mounted() {
      this.getCurrentUser()
      this.defaultData();	
      this.getAITSList();
    // this.getSubTypes();
  },
  computed: {
       ...mapState("userStore", ["modules","user"]),
    },
  data() {
    return {
      CONSTANTS_REF : constants,
      tab: null,
      tabsList: [],
      modules1: [],
	    searchText: "",
      search: "",
      icons: false,
      centered: false,
      grow: false,
      vertical: false,
      prevIcon: false,
      nextIcon: false,
      right: false,
      popUpMessage: "This feature is only available for Premium Users.",
      isOfflineTest:true,
      isAITS: true,
      instituteId:'',
      showAITSTab: true
    };
  },
  methods: {
    ...mapMutations("app", ["addBreadCrumbChilde"]),
    ...mapActions({
      getTestSubTypes: "utilStore/getTestSubTypes",
      updateModules: "userStore/updateModules"
    }),
    defaultData() {
      let routeName = this.$route.name;    
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.tab = crd.selectedTab ? crd.selectedTab : 'Online';
      }
      // console.log(this.$route.$route);
	  this.checkSessionData();
    },
    
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

    //   if (rp.params.resetPage || !crd.routeName) {
        // let tabDetail = {};
        // this.tabsList.map((t) => {
          let subTabDetails = {
          page: 1,
          orderBy: {
				field: "created_at",
                order: "DESC",
          },
          requestIds:[]
        };
        let tabDetail = {
          Online: subTabDetails,
          Offline: subTabDetails
        };
        // });
        let routeDetails = {
          routeName: rp.name,
          selectedTab: this.tab,
          tabDetails: tabDetail,
          searchText: "",
        };
        this.setRouteDetails(routeDetails);
    //   }
    },
    isOfflineTestVisible(){
      const isOnline = this.modules ? this.modules.findIndex(m=>m.module_id === 9) > -1 : "";
      const isOffline = this.modules ? this.modules.findIndex(m=>m.module_id === 13) > -1 : "";
      const isAITS = this.modules && Array.isArray(this.modules.AITS_INSTITUTE_ID) && this.modules.AITS_INSTITUTE_ID.length > 0;
     return {isOffline,isOnline,isAITS}
    },
     getCurrentUser(){
      let instituteData = JSON.parse(localStorage.getItem("myInstitute"));
      this.instituteId = instituteData?.id
    },

   getAITSList(){
      this.showAITSTab = this.user.has_aits_test
    },

  },
  watch: {

    tab(val, oldVal) {
      if (oldVal) {
        // only when tab is changed and not on page load
        let routeName = this.$route.name;
        this.setRouteDetails({ routeName, selectedTab: val,searchText:"" });
		this.searchText = "";
    
		this.search = "";
      }
      this.addBreadCrumbChilde([
        {
          text: val,
          disabled: false,
        },
      ]);
    },
    
  },
};
</script>
